import _implicitStylesheets from "./warningModal.css";
import _implicitScopedStylesheets from "./warningModal.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import _adsGridItem from "ads/gridItem";
import _adsContentText from "ads/contentText";
import _adsGrid from "ads/grid";
import _adsButton from "ads/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="button-padding${0}"${2}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "modal-content": true
  },
  props: {
    "gridAlignItems": "spread",
    "gridAxis": "row",
    "gridFlow": "wrap",
    "gridGap": "x-small",
    "gridRowGap": "medium",
    "gridFlex": "grow"
  },
  key: 0
};
const stc1 = {
  props: {
    "gridItemSize": "1:8",
    "gridItemAlign": "center"
  },
  key: 1
};
const stc2 = {
  props: {
    "gridItemSize": "7:8"
  },
  key: 3
};
const stc3 = {
  props: {
    "typeStyle": "body-2"
  },
  key: 4
};
const stc4 = {
  classMap: {
    "modal-footer": true
  },
  key: 5
};
const stc5 = {
  "right-padding": true
};
const stc6 = {
  "data-test-id": "close-dialog"
};
const stc7 = {
  "size": "medium",
  "variant": "tertiary"
};
const stc8 = {
  "data-test-id": "add-price-button"
};
const stc9 = {
  "size": "medium",
  "variant": "secondary"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, d: api_dynamic_text, t: api_text, b: api_bind, sp: api_static_part, st: api_static_fragment, h: api_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_custom_element("ads-grid", _adsGrid, stc0, [api_custom_element("ads-grid-item", _adsGridItem, stc1, [api_custom_element("ads-icon", _adsIcon, {
    props: {
      "variant": "warning",
      "fill": $cmp.fillWarningIconColor,
      "symbol": "warning",
      "size": "medium"
    },
    key: 2
  })]), api_custom_element("ads-grid-item", _adsGridItem, stc2, [api_custom_element("ads-content-text", _adsContentText, stc3, [api_text(api_dynamic_text($cmp.descriptionText))])])]), api_element("div", stc4, [api_custom_element("ads-button", _adsButton, {
    classMap: stc5,
    attrs: stc6,
    props: stc7,
    key: 6,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleDialogClose))
    }
  }, [api_text(api_dynamic_text($cmp.cancelLabel))]), api_custom_element("ads-button", _adsButton, {
    attrs: stc8,
    props: stc9,
    key: 7,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleSubmitAction))
    }
  }, [api_static_fragment($fragment1, 9, [api_static_part(1, null, api_dynamic_text($cmp.submitLabel))]), api_custom_element("ads-icon", _adsIcon, {
    slotAssignment: "end",
    props: {
      "variant": "",
      "fill": $cmp.fillIconColor,
      "symbol": "forward",
      "size": "small"
    },
    key: 10
  })])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-52f6hcckjbk";
tmpl.legacyStylesheetToken = "pricing-warningModal_warningModal";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
